import { InputCopy } from './input-copy';
import InputGroup from './input-group';

export { InputCopy };

export default InputGroup;
